<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas.planos' })"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Bimestral
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn depressed color="primary" @click="() => [visualizarPdf(plano.id)]">
          Visualizar Pdf
          <v-icon small right> mdi-note </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" lg="12">
        <v-card>
          <v-card-text>
            <label for="">Professor</label>
            <v-input>
              {{ plano.gestao_de_aula.professor ? plano.gestao_de_aula.professor.nome : "- - - " }}
            </v-input>

            <label for="">Turma</label>
            <v-input>
              {{ plano.gestao_de_aula.turma ? plano.gestao_de_aula.turma.descricao : "- - - " }}
            </v-input>

            <label for="">Disciplina</label>
            <v-input>
              {{ plano ? plano.disciplina.descricao : "- - - " }}
            </v-input>

            <label for="">Data lançamento</label>
            <v-input>
              <v-chip>
                {{
                  plano ? plano.created_at.substr(0, 10).split("-").reverse().join("/") : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="">Última atualização</label>
            <v-input>
              <v-chip>
                {{
                  plano ? plano.updated_at.substr(0, 10).split("-").reverse().join("/") : "- - - "
                }}
              </v-chip>
            </v-input>
            <v-combobox v-model="seriesSelecionadas" chips label="Series" multiple readonly />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="2">
                <label for="">Status</label>
                <e-situacao-plano :plano="plano" v-on:update="listarPlano" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>

                <label for="">Período</label>
                <v-input> {{ plano.etapa.descricao }}</v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col v-if="plano.disciplina.is_especial">
                <v-divider></v-divider>

                <label>UNIDADES TEMÁTICAS</label>
                <v-textarea
                  dense
                  color="primary"
                  :value="
                    plano.unidades_tematicas_especial ? plano.unidades_tematicas_especial : '- - -'
                  "
                  readonly
                  hide-details
                  no-resize
                  solo
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="plano.disciplina.is_especial">
                <v-divider class="mt-2 mb-2"></v-divider>

                <label>OBJETOS DO CONHECIMENTO</label>
                <v-textarea
                  dense
                  color="primary"
                  :value="
                    plano.objetos_conhecimento_especial
                      ? plano.objetos_conhecimento_especial
                      : '- - -'
                  "
                  readonly
                  hide-details
                  no-resize
                  solo
                ></v-textarea>
              </v-col>

              <v-col v-else>
                <v-divider class="mb-2"></v-divider>
                <label>OBJETOS DO CONHECIMENTO</label>
                <div v-if="objetosConhecimentoUnicos.length > 0">
                  <v-input
                    v-for="(objeto, index) in objetosConhecimentoUnicos"
                    :key="index"
                    label
                    large
                    color="primary"
                    class="ma-1 descricao-wrap"
                  >
                    {{ objeto || "[NÃO INFORMADO]" }}
                  </v-input>
                </div>
                <div v-else-if="plano.objeto_conhecimento && plano.objeto_conhecimento.trim()">
                  <v-textarea
                    label
                    large
                    solo
                    color="primary"
                    class="ma-1 descricao-wrap"
                    :value="plano.objeto_conhecimento"
                    readonly
                  />
                </div>
                <div v-else>
                  <v-chip class="ma-1" color="grey" outlined> - - - </v-chip>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col v-if="plano.disciplina.is_especial">
                <v-divider class="mt-2 mb-2"></v-divider>
                <label>HABILIDADES</label>
                <v-textarea
                  dense
                  color="primary"
                  :value="plano.habilidades_especial ? plano.habilidades_especial : '- - -'"
                  readonly
                  hide-details
                  no-resize
                  solo
                ></v-textarea>
              </v-col>

              <v-col v-else>
                <v-divider class="mb-2"></v-divider>
                <label>HABILIDADES</label>
                <div v-if="habilidadesFormatadas.length > 0">
                  <v-card
                    v-for="(habilidade, index) in habilidadesFormatadas"
                    :key="index"
                    class="pa-3 my-2"
                    outlined
                  >
                    <div class="d-flex flex-column">
                      <v-chip
                        v-if="habilidade.apelido"
                        small
                        color="primary"
                        class="mb-2 align-self-start"
                      >
                        {{ habilidade.apelido }}
                      </v-chip>
                      <div class="text-body-2">
                        {{ habilidade.descricao }}
                      </div>
                    </div>
                  </v-card>
                </div>
                <div v-else-if="plano.habilidade_texto && plano.habilidade_texto.trim()">
                  <v-textarea
                    label
                    large
                    solo
                    color="primary"
                    :value="plano.habilidade_texto"
                    class="ma-1 descricao-wrap"
                  >
                  </v-textarea>
                </div>
                <div v-else>
                  <v-chip class="ma-1" color="grey" outlined> - - - </v-chip>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col v-if="descritoresFormatados.length > 0">
                <v-divider class="mb-2"></v-divider>
                <label>DESCRITORES</label>
                <div>
                  <v-chip
                    v-for="(descritor, index) in descritoresFormatados"
                    :key="index"
                    class="mt-1 mr-2"
                    color="primary"
                    outlined
                    style="white-space: normal; height: auto; min-height: 32px"
                  >
                    {{ descritor.texto }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider class="mb-2"></v-divider>
                <label>PROCEDIMENTO METODOLÓGICO</label>
                <div v-if="plano.metodologia && plano.metodologia.trim()">
                  <v-textarea
                    label
                    large
                    solo
                    color="primary"
                    :value="plano.metodologia"
                    class="ma-1 descricao-wrap"
                  >
                  </v-textarea>
                </div>
                <div v-else>
                  <v-chip class="ma-1" color="grey" outlined> - - - </v-chip>
                </div>
              </v-col>
            </v-row>

            <!-- AVALIAÇÃO DA APRENDIZAGEM -->
            <v-row>
              <v-col>
                <v-divider class="mb-4"></v-divider>
                <label>AVALIAÇÃO</label>
                <div v-if="avaliacaoAprendizagemItens.length > 0">
                  <v-chip
                    v-for="(avaliacao, index) in avaliacaoAprendizagemItens"
                    :key="index"
                    class="mt-1 mr-2"
                    color="warning"
                    outlined
                  >
                    {{ avaliacao }}
                  </v-chip>
                </div>
                <div
                  v-else-if="
                    plano.avaliacao_aprendizagem_texto && plano.avaliacao_aprendizagem_texto.trim()
                  "
                >
                  <v-textarea
                    label
                    large
                    solo
                    color="warning"
                    :value="plano.avaliacao_aprendizagem_texto"
                    class="ma-1 descricao-wrap"
                  >
                  </v-textarea>
                </div>
                <div v-else>
                  <v-chip class="ma-1" color="grey" outlined> - - - </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ModalCarteira :dialog="dialog" :pdf="pdf" @close="fecharVisualizacaoPdf" />
  </main-template>
</template>

<script>
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";

export default {
  components: {
    ModalCarteira,
  },
  data() {
    return {
      dialog: false,
      pdf: null,
      showSnackbar: false,
      plano: {},
      plano_id: null,
      seriesSelecionadas: [],
      habilidadeSelecionadas: [],
      recursosSelecionados: [],
      avaliacoesSelecionadas: [],
      duvidasSelecionadas: [],
    };
  },
  computed: {
    habilidades() {
      try {
        return JSON.parse(this.plano.habilidades || "[]");
      } catch (error) {
        return [];
      }
    },

    temPraticasLinguagem() {
      return this.habilidades.some(
        (h) => h.praticas_linguagem && h.praticas_linguagem.trim() !== ""
      );
    },

    praticasLinguagemUnicas() {
      const praticas = this.habilidades
        .map((h) => h.praticas_linguagem)
        .filter((p) => p && p.trim() !== "");

      return [...new Set(praticas)];
    },

    unidadesTematicasUnicas() {
      const unidades = this.habilidades
        .map((h) => h.unidades_tematicas)
        .filter((u) => u && u.trim() !== "");

      return [...new Set(unidades)];
    },
    objetosConhecimentoUnicos() {
      const objetos = this.habilidades
        .map((h) => h.objeto_conhecimento)
        .filter((o) => o && o.trim() !== "");

      return [...new Set(objetos)];
    },
    habilidadesFormatadas() {
      if (this.habilidades.length === 0) {
        return [];
      }

      return this.habilidades.map((h) => ({
        apelido: h.apelido || "",
        descricao: h.descricao || "[NÃO INFORMADO]",
      }));
    },
    descritoresFormatados() {
      const descritores = this.plano.descritores || [];

      if (!Array.isArray(descritores) || descritores.length === 0) {
        return [];
      }

      return descritores.map((d) => {
        const seq = d.sequencia ? d.sequencia.split(".")[0] : "0";
        const cod = (d.prefixo || "") + parseInt(seq, 10);
        const descricao = d.descricao || "[NÃO INFORMADO]";

        return {
          codigo: cod,
          descricao,
          texto: `${cod} - ${descricao}`,
        };
      });
    },
    avaliacaoAprendizagemItens() {
      try {
        const avaliacoes = JSON.parse(this.plano.avaliacao_aprendizagem || "[]");
        return avaliacoes.filter((item) => item && item.trim() !== "");
      } catch (error) {
        return [];
      }
    },
  },
  async mounted() {
    await this.getId();
    this.listarPlano(this.pageNumber);
  },
  methods: {
    async getId() {
      const { id } = this.$route.params;
      this.plano_id = id;
    },
    async listarPlano() {
      this.$loaderService.open("Carregando Plano");
      try {
        const { data } = await this.$services.planosService.show(this.plano_id);
        this.plano = { ...data.planoBimestral };
        this.seriesSelecionadas = this.plano.gestao_de_aula.turma.series.map((s) => s.descricao);
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async visualizarPdf(planoId) {
      this.$loaderService.open("Carregando Plano");
      try {
        this.pdf = await this.$services.planosService.pdf(planoId);
        this.dialog = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    fecharVisualizacaoPdf() {
      this.pdf = null;
      this.dialog = false;
    },
  },
};
</script>

<style>
.descricao-wrap {
  white-space: normal;
  word-break: break-word;
}
</style>
